import React, { forwardRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  format,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  getDay,
  isToday,
  isSameDay
} from 'date-fns';
import './Calendar.css';

const CustomCalendarHeader = forwardRef(({ value, onClick }, ref) => (
  <h2 className="calendar-month-title" onClick={onClick} ref={ref}>
    {value}
  </h2>
));

const Calendar = ({ currentMonth, events, onPrevMonth, onNextMonth, onEventSelect, onMonthChange, onGoToToday }) => {
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const firstDayOfMonth = startOfMonth(currentMonth);
  const lastDayOfMonth = endOfMonth(currentMonth);

  const daysInMonth = eachDayOfInterval({
    start: firstDayOfMonth,
    end: lastDayOfMonth,
  });

  const startingDayIndex = getDay(firstDayOfMonth);

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <div className="calendar-nav-controls-left">
          <button onClick={onPrevMonth} className="nav-button prev-button" aria-label="Previous month">‹</button>
          <button onClick={onNextMonth} className="nav-button next-button" aria-label="Next month">›</button>
          <button onClick={onGoToToday} className="today-button">Today</button>
        </div>
        
        <div className="calendar-header-center-title">
          <DatePicker
            selected={currentMonth}
            onChange={onMonthChange}
            dateFormat="MMMM yyyy" 
            showMonthYearPicker
            customInput={<CustomCalendarHeader />}
          />
        </div>
      </div>

      <div className="days-of-week-header">
        {daysOfWeek.map(day => (
          <div key={day} className="day-of-week">{day}</div>
        ))}
      </div>

      <div className="calendar-grid">
        {Array.from({ length: startingDayIndex }).map((_, index) => (
          <div key={`empty-${index}`} className="day-cell empty"></div>
        ))}
        {daysInMonth.map(day => {
          const eventsForDay = events.filter(event => event.date && isSameDay(event.date, day));
          return (
            <div key={day.toString()} className={`day-cell ${isToday(day) ? 'today' : ''}`}>
              <span className="day-number">{format(day, 'd')}</span>
              <div className="events-container">
                {eventsForDay.map(event => (
                  <div
                    key={event.id}
                    className="event-chip"
                    style={{ backgroundColor: event.category_details?.color || '#6c757d' }}
                    onClick={() => onEventSelect(event)}
                  >
                    {event.title}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
